import Angular from "angular";
import {DataLoadingEvent} from "core/interceptors/loading.interceptor";

var IfDataLoadingModule = Angular.module('if-data-loading', []);

IfDataLoadingModule.directive('ifDataLoading', ['ngIfDirective', function (ngIfDirective) {
    var ngIf = ngIfDirective[0];
    var dataLoading = false;

    return {
        transclude: ngIf.transclude,
        priority: ngIf.priority - 1,
        terminal: ngIf.terminal,
        restrict: ngIf.restrict,

        link: function (scope, element, attributes) {
            var ifLoading = true;
            if (attributes.ifDataLoading != "") {
                ifLoading = scope.$eval(attributes.ifDataLoading);
            }

            scope.$on(DataLoadingEvent.Start, function () {
                dataLoading = true;
            });

            scope.$on(DataLoadingEvent.Stop, function () {
                dataLoading = false;
            });

            // find the initial ng-if attribute
            var initialNgIf = attributes.ngIf, ifEvaluator;

            // if it exists, evaluates ngIf && ifAuthenticated
            if (initialNgIf) {
                ifEvaluator = function () {
                    return scope.$eval(initialNgIf) && (ifLoading == dataLoading);
                }
            } else { // if there's no ng-if, process normally
                ifEvaluator = function () {
                    return (ifLoading == dataLoading);
                }
            }

            attributes.ngIf = ifEvaluator;
            ngIf.link.apply(ngIf, arguments);
        }
    };
}]);

export default IfDataLoadingModule;




// WEBPACK FOOTER //
// ./src/modules/core/components/loading-indicator/if-data-loading.directive.js